<script>
import $ from 'domtastic';
import find from 'lodash/find';
import get from 'lodash/get';
import { mapState, mapGetters } from 'vuex';

import IconChevronDown from '../icons/IconChevronDown';
import BuyerButton from './BuyerButton';
import BuyerCheckbox from './BuyerCheckbox';
import CollectionFilters from './CollectionFilters';

export default {
  components: {
    IconChevronDown,
    BuyerButton,
    BuyerCheckbox,
    CollectionFilters,
  },
  props: {
    sortOptions: Array,
    selectedProductType: String,
    selectedSortText: String,
    selectedCategory: Object,
    selectedParentCategory: Object,
    selectedSubCategory: Object,
    selectedSubSubCategory: Object,
    formattedProductType: String,
    categories: Object,
    productTypes: Array,
    search: String,
    showMobileFilterModal: Boolean,
    showMobileSortModal: Boolean,
  },
  data: () => ({
    showSortMenu: false,
  }),
  computed: {
    showFiltersLabel() {
      return (
        this.selectedParentCategory && this.selectedParentCategory.category !== 'All' ||
        this.selectedSubCategory && this.selectedSubCategory.category !== 'All' ||
        this.selectedSubSubCategory && this.selectedSubSubCategory.category !== 'All' ||
        this.formattedProductType
      );
    },
    showClearAll() {
      let count = 0;

      if (this.selectedParentCategory && this.selectedParentCategory.category !== 'All') {
        count++;
      }

      if (this.selectedSubCategory && this.selectedSubCategory.category !== 'All') {
        count++;
      }

      if (this.selectedSubSubCategory && this.selectedSubSubCategory.category !== 'All') {
        count++;
      }

      if (this.formattedProductType) {
        count++
      }

      return count > 1;
    }
  },
  created() {
    if (this.showMobileSortModal || this.showMobileFilterModal) {
      this.$emit('lock-scroll', true);
    }

    $(window).on('click', this.$_closeSortMenu);
  },
  beforeDestroy() {
    $(window).off('click', this.$_closeSortMenu);
  },
  methods: {
    $_closeSortMenu() {
      this.showSortMenu = false;
    },
    handleClearCategory() {
      this.$emit('update-state', { property: 'selectedCategory', value: null });

      this.$emit('get-campaigns');
    },
    handleClearSubCategory() {
      this.$emit('update-state', { property: 'selectedCategory', value: this.selectedParentCategory });

      this.$emit('get-campaigns');
    },
    handleClearSubSubCategory() {
      this.$emit('update-state', { property: 'selectedCategory', value: this.selectedSubCategory });

      this.$emit('get-campaigns');
    },
    handleClearProductType() {
      this.$emit('update-state', { property: 'selectedProductType', value: null });

      this.$emit('get-campaigns');
    },
    handleClearAll() {
      this.$emit('update-state', { property: 'selectedCategory', value: null });
      this.$emit('update-state', { property: 'selectedProductType', value: null });

      this.$emit('get-campaigns');
    },
    handleSortInput(value, newText) {
      if (this.selectedSortText !== newText) {
        this.$emit('update-state', { property: 'selectedSort', value });

        this.$emit('get-campaigns');
      }
    },
    async toggleFilterModal() {
      this.$emit('update-state', { property: 'showMobileFilterModal', value: !this.showMobileFilterModal });

      await this.$nextTick();

      this.$emit('lock-scroll', this.showMobileFilterModal);
    },
    async toggleSortModal() {
      this.$emit('update-state', { property: 'showMobileSortModal', value: !this.showMobileSortModal });

      await this.$nextTick();

      this.$emit('lock-scroll', this.showMobileSortModal);
    },
    handleShowSortMenu(e) {
      e.stopPropagation();

      this.showSortMenu = !this.showSortMenu;
    },
  },
};
</script>

<template lang='pug'>
.flex.items-center.md_border-b.md_border-brand-secondary-75.pb-1.md_pb-1_5.flex-wrap.md_flex-no-wrap
  .flex.md_hidden.w-full.border-t.border-b.border-border
    .w-1-2.border-r.border-border.p-1(
      tabindex='0',
      @click='toggleFilterModal',
    )
      svg.text-brand.inline.ml-_5(xmlns='http://www.w3.org/2000/svg', width='21', height='21', viewBox='0 0 21 21')
        path.fill-current(d='M18.481 1.749l-6.823 10.153a.864.864 0 0 0-.15.489v4.47l-2.006 1.513v-5.983a.864.864 0 0 0-.15-.489L2.52 1.75zM7.75 20.127c.111 1.098 1.187.939 1.401.699l3.755-2.833a.879.879 0 0 0 .347-.699v-4.637l7.6-11.294C21.313.617 20.65 0 20.126 0H.874C-.026.03-.16 1.007.15 1.363l7.599 11.294v7.47z')
      span.align-middle.text-3xl.ml-1.text-brand-secondary-850 Filter
    .w-1-2.p-1(
      tabindex='0',
      @click='toggleSortModal',
    )
      svg.text-brand.inline.ml-_5(xmlns='http://www.w3.org/2000/svg', width='21', height='21', viewBox='0 0 21 21')
        path.fill-current(d='M20.657 5.406L15.432.254a.881.881 0 0 0-1.237 0L8.973 5.406a.852.852 0 0 0 0 1.22.881.881 0 0 0 1.237 0l3.72-3.668v15.098c0 .484.395.873.885.873s.886-.39.886-.873V2.958l3.72 3.668a.881.881 0 0 0 1.236 0 .852.852 0 0 0 0-1.22z')
        path.fill-current(d='M11.856 14.375a.881.881 0 0 0-1.237 0l-3.72 3.667V2.945a.877.877 0 0 0-.885-.873c-.49 0-.886.39-.886.873v15.097l-3.72-3.667a.881.881 0 0 0-1.236 0 .852.852 0 0 0 0 1.22l5.225 5.152a.881.881 0 0 0 1.237 0l5.226-5.153a.855.855 0 0 0-.004-1.22z')
      span.align-middle.text-3xl.ml-1.text-brand-secondary-850 Sort

    .fixed.top-0.left-0.w-full.h-full.z-125(v-if='showMobileFilterModal')
      .bg-black.opacity-50.h-full.w-full(@click='toggleFilterModal')
      .absolute.top-0.mt-6.bg-white.w-full.absolute--center-horizontal.container.flex.flex-col.mp-sort__filter-modal
        svg.h-2.absolute.right-1.top-1_5(
          tabindex='0',
          viewBox='0 0 24 24',
          @click='toggleFilterModal',
          @keyup.enter='toggleFilterModal',
        )
          path.fill-current(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')
        .px-1_5.py-1.text-6xl.border-b.border-border.font-bold Filter
        .overflow-scroll.flex-grow
          collection-filters.px-1_5.mb-1(
            :selected-category='selectedCategory',
            :selected-product-type='selectedProductType',
            :categories='categories',
            :product-types='productTypes',
            @update-state='$emit("update-state", $event)',
            @get-campaigns='$emit("get-campaigns")',
          )
        buyer-button(@click='toggleFilterModal')
          .text-xl APPLY FILTER

    .fixed.top-0.left-0.w-full.h-full.z-125(v-if='showMobileSortModal')
      .bg-black.opacity-50.h-full.w-full(@click='toggleSortModal')
      .absolute.top-0.mt-6.bg-white.w-full.absolute--center-horizontal.container.flex.flex-col.mp-sort__filter-modal
        svg.h-2.absolute.right-1.top-1_5(
          tabindex='0',
          viewBox='0 0 24 24',
          @click='toggleSortModal',
          @keyup.enter='toggleSortModal',
        )
          path.fill-current(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')
        .px-1_5.py-1.text-6xl.border-b.border-border.font-bold Sort
        .overflow-scroll.flex-grow
          .px-1_5.mb-1.mt-2
            buyer-checkbox.text-brand-secondary-850.cursor-pointer.hover_underline.mt-_75(
              v-for='option in sortOptions',
              :small='$mq === "sm" || $mq === "md" ? false : true',
              :key='option.id',
              :label='option.value',
              :model='option.value === selectedSortText',
              :value='true',
              @input='handleSortInput(option.key, option.value)',
            )
        buyer-button(@click='toggleSortModal')
          .text-xl APPLY SORT

  .flex-grow.flex.items-center.flex-wrap.md_flex-no-wrap.px-1_5.md_px-0.mt-1_5.md_mt-0
    .text-xl.text-brand-secondary-850.md_text-brand-secondary.md_text-3xl.mr-2.w-full.md_w-auto.font-bold.md_font-normal(
      v-if='showFiltersLabel',
    ) Filters:

    .px-1.py-_5.cursor-pointer.text-xl.md_text-sm.bg-brand-secondary-75.inline-block.mt-_5.md_mt-0.mr-1.hover_bg-brand-secondary-200.select-none(
      v-if='selectedParentCategory',
      tabindex='0',
      @click='handleClearCategory',
      @keyup.enter='handleClearCategory',
    ) {{selectedParentCategory.category}}
      svg.h-1.inline-block.ml-_5(viewBox='0 0 24 24')
        path(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

    .px-1.py-_5.cursor-pointer.text-xl.md_text-sm.bg-brand-secondary-75.inline-block.mt-_5.md_mt-0.mr-1.hover_bg-brand-secondary-200.select-none(
      v-if='selectedSubCategory',
      tabindex='0',
      @click='handleClearSubCategory',
      @keyup.enter='handleClearSubCategory',
    ) {{selectedSubCategory.category}}
      svg.h-1.inline-block.ml-_5(viewBox='0 0 24 24')
        path(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

    .px-1.py-_5.cursor-pointer.text-xl.md_text-sm.bg-brand-secondary-75.inline-block.mt-_5.md_mt-0.mr-1.hover_bg-brand-secondary-200.select-none(
      v-if='selectedSubSubCategory',
      tabindex='0',
      @click='handleClearSubSubCategory',
      @keyup.enter='handleClearSubSubCategory',
    ) {{selectedSubSubCategory.category}}
      svg.h-1.inline-block.ml-_5(viewBox='0 0 24 24')
        path(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

    .px-1.py-_5.cursor-pointer.text-xl.md_text-sm.bg-brand-secondary-75.inline-block.mt-_5.md_mt-0.mr-1.hover_bg-brand-secondary-200.select-none(
      v-if='formattedProductType',
      tabindex='0',
      @click='handleClearProductType',
      @keyup.enter='handleClearProductType',
    ) {{formattedProductType}}
      svg.h-1.inline-block.ml-_5(viewBox='0 0 24 24')
        path(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

    .text-sm.text-brand-secondary-400.hover_underline.cursor-pointer.ml-_5.lg_ml-1.mt-_5.md_mt-0.hidden.md_block(
      v-if='showClearAll',
      tabindex='0',
      @click='handleClearAll',
      @keyup.enter='handleClearAll',
    ) Clear All

  .select-none.hidden.md_block Sort:&nbsp;
    .inline-block.text-brand.cursor-pointer.hover_text-brand-900.relative(
      tabindex='0',
      @click='handleShowSortMenu',
      @keyup.enter='handleShowSortMenu',
    ) {{selectedSortText}}
      icon-chevron-down.ml-_5
      .absolute.top-full.absolute--center-horizontal.bg-white.border.border-border.rounded.py-_5.mt-_5.mp-sort__dropdown.text-center.z-10(
        v-show='showSortMenu',
      )
        p.px-1.py-_5.whitespace-no-wrap.leading-none.hover_text-brand-900.text-brand(
          v-for='option in sortOptions',
          tabindex='0',
          @click='handleSortInput(option.key, option.value)',
          @keyup.enter='handleSortInput(option.key, option.value)',
        ) {{option.value}}
</template>

<style>
@import '~import/index';

.mp-sort {
  &__dropdown {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.06);
  }

  &__filter-modal {
    height: calc(100% - 6rem);
  }
}
</style>